export default __webpack_public_path__ + "locales/el-GR/Settings.json?hash=0ff39fda9bf19847d801fe7b54586eb6";